import React, { Fragment } from 'react';
import { Facebook, Linkedin, Twitter, Instagram } from 'react-feather';
import { Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import { Btn, H4, H6, LI, UL } from '../../../AbstractElements';
import { Link } from 'react-router-dom';

const RegisterFrom = () => {
    return (
        <Fragment>
            <div className="login-card">
                <div className="login-main">
                    <Form className="theme-form login-form">
                        <H4>Create your account</H4>
                        <H6>Enter your personal details to create account</H6>
                        <FormGroup>
                            <Label className="col-form-label">Your Name</Label>
                            <Row>
                                <Col xs='6'>
                                    <Input className="form-control" type="text" required="" placeholder="Fist Name" />
                                </Col>
                                <Col xs='6'>
                                    <Input className="form-control" type="email" required="" placeholder="Last Name" />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Label className="col-form-label">Email Address</Label>
                            <Input className="form-control" type="email" required="" placeholder="Test@gmail.com" />
                        </FormGroup>
                        <FormGroup className="position-relative">
                            <Label className="col-form-label">Password</Label>
                            <Input className="form-control" type="password" name="login[password]" required="" placeholder="*********" />
                            <div className="show-hide"><span className="show"> </span></div>
                        </FormGroup>
                        <FormGroup>
                            <div className="checkbox">
                                <Input id="checkbox1" type="checkbox" />
                                <Label className="text-muted" for="checkbox1">Agree with <span>Privacy Policy</span></Label>
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <Btn attrBtn={{ className: 'd-block w-100', color: 'primary', type: 'submit' }}>Create Account</Btn>
                        </FormGroup>
                        <div className="login-social-title">
                            <H6 attrH6={{ className: 'text-muted or mt-4' }}>Or Sign up with</H6>
                        </div>
                        <FormGroup>
                            <UL attrUL={{ as: 'ul', className: 'login-social d-flex justify-content-center flex-row' }} >
                                <LI className="bg-light"><a href="https://www.linkedin.com/login" ><Linkedin /></a></LI>
                                <LI className="bg-light"><a href="https://www.linkedin.com/login" ><Twitter /></a></LI>
                                <LI className="bg-light"><a href="https://www.linkedin.com/login" ><Facebook /></a></LI>
                                <LI className="bg-light"><a href="https://www.instagram.com/login" ><Instagram /></a></LI>
                            </UL>
                        </FormGroup>
                        <p className="mb-0 text-center">Already have an account?<Link className="ms-2" to={`${process.env.PUBLIC_URL}/pages/authentication/login-simple`}>Sign in</Link></p>
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};

export default RegisterFrom;